import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import './index.css';
import React from 'react';
import cx from 'classnames';
import toTitleCase from '@clearscore-group/lib.normalize.title-case';
import { timing } from '@clearscore/ui.rainbow.tokens';
var Size = {
  TINY: 'TINY',
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
  FULL_WIDTH: 'FULL_WIDTH'
};
var Theme = {
  LIGHT: 'LIGHT',
  DARK: 'DARK'
};
var styles = {
  "component": "component--RUP-9",
  "spinner": "spinner--x-iWM",
  "isSizeTiny": "isSizeTiny--cwCn5",
  "isSizeSmall": "isSizeSmall--yGi-1",
  "isSizeMedium": "isSizeMedium--v-ljh",
  "isSizeLarge": "isSizeLarge--PDnCU",
  "isSizeFullWidth": "isSizeFullWidth---onhY",
  "isThemeLight": "isThemeLight--SWEtD",
  "isThemeDark": "isThemeDark--rIO5C",
  "srOnly": "srOnly--87tOU",
  "container": "container--V9lIZ"
};
var Loader = function Loader(_ref) {
  var _ref$size = _ref.size,
    _size = _ref$size === void 0 ? Size.MEDIUM : _ref$size,
    _ref$animationDuratio = _ref.animationDuration,
    _animationDuration = _ref$animationDuratio === void 0 ? timing['rnb-timing-normal'] : _ref$animationDuratio,
    isFullPage = _ref.isFullPage,
    theme = _ref.theme,
    children = _ref.children;
  var inlineStyles = {
    animationDuration: _animationDuration
  };
  var loader = /*#__PURE__*/React.createElement("div", {
    "data-qa": "loader",
    className: cx(styles.component, styles["isSize".concat(toTitleCase(_size))], _defineProperty({}, styles["isTheme".concat(toTitleCase(theme))], theme)),
    "aria-live": "polite",
    style: inlineStyles
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.srOnly
  }, children || 'loading'));
  if (isFullPage) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.container,
      "data-qa": "loader-container"
    }, loader);
  }
  return loader;
};
Loader.Size = Size;
Loader.Theme = Theme;
export default Loader;